import React, { useState } from 'react'
import Hero from '../components/Hero';
import { useIntl } from 'react-intl';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export type AccreditationPageProps = {};

export enum AccredidationTypes {
  EMA = 'ema',
  DGN = 'dgn',
  IFT = 'ift',
  CONUEE = 'conuee',
  CRT = 'crt',
}

const AccreditationPage: React.FC<AccreditationPageProps> = () => {
  const [activeTab, setActiveTab] = useState<AccredidationTypes>(AccredidationTypes.EMA);
  const intl = useIntl();

  return (
    <div className="w-full">
      <Hero bgImage={'/img/accred-rocket-rs.png'} heading={intl.formatMessage({id: 'accreditation'})} />
      <div className="content gap-8 items-center text-center">
        <h1 className='text-3xl font-bold text-secondary uppercase'>
          {
            intl.formatMessage({
              id: 'accreditation',
              defaultMessage: 'Accreditation'
            })
          }
        </h1>
        <p>
          {
            intl.formatMessage({
              id: 'accred-intro',
            })
          }
        </p>
        <p>
          {
            intl.formatMessage({
              id: 'accred-intro-2',
            })
          }
        </p>
        {/* <h3 className='text-2xl font-bold text-secondary uppercase'>
          {
            intl.formatMessage({
              id: 'accred-office',
              defaultMessage: 'EMA Accreditation Office'
            })
          }
        </h3>
        <img src="/img/EMA-accred.png" alt="" /> */}
        <div className="w-full flex justify-center">
          <ul className="flex gap-4">
            <li>
              <button
                className={`border-2 border-primary px-4 py-2 text-sm font-bold text-primary uppercase rounded-md ${
                  activeTab === AccredidationTypes.EMA? 'bg-main text-white' : ''
                }`}
                onClick={() => setActiveTab(AccredidationTypes.EMA)}
              >
                EMA
              </button>
            </li>
            <li>
              <button
                className={`border-2 border-primary px-4 py-2 text-sm font-bold text-primary uppercase rounded-md ${
                  activeTab === AccredidationTypes.DGN? 'bg-main text-white' : ''
                }`}
                onClick={() => setActiveTab(AccredidationTypes.DGN)}
              >
                DGN
              </button>
            </li>
            <li>
              <button
                className={`border-2 border-primary px-4 py-2 text-sm font-bold text-primary uppercase rounded-md ${
                  activeTab === AccredidationTypes.CONUEE? 'bg-main text-white' : ''
                }`}
                onClick={() => setActiveTab(AccredidationTypes.CONUEE)}
              >
                CONUEE
              </button>
            </li>
            <li>
              <button
                className={`border-2 border-primary px-4 py-2 text-sm font-bold text-primary uppercase rounded-md ${
                  activeTab === AccredidationTypes.CRT? 'bg-main text-white' : ''
                }`}
                onClick={() => setActiveTab(AccredidationTypes.CRT)}
              >
                CRT
              </button>
            </li>
          </ul>
        </div>
        <div className="min-h-screen">          
          {activeTab === AccredidationTypes.EMA && (
            <>
            <Document renderMode='canvas' onError={(e) => {console.log("!!!!", e)}} file={'/pdf/acreditation/ema/Diploma EMA.pdf'}>
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={0} />
            </Document>
            <Document renderMode='canvas' onError={(e) => {console.log("!!!!", e)}} file={'/pdf/acreditation/ema/Anexo técnico EMA.pdf'}>
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={0} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={1} />
            </Document>
            </>
          )}
          {activeTab === AccredidationTypes.DGN && (
            <Document renderMode='canvas' onError={(e) => {console.log("!!!!", e)}} file={'/pdf/acreditation/dgn/Aprobacion DGN.pdf'}>
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={0} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={1} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={2} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={3} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={4} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={5} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={6} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={7} />
            </Document>
          )}
          {activeTab === AccredidationTypes.CONUEE && (
            <Document renderMode='canvas' onError={(e) => {console.log("!!!!", e)}} file={'/pdf/acreditation/conuee/Aprobacion CONUEE 2026.pdf'}>
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={0} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={1} />
            </Document>
          )}
          {activeTab === AccredidationTypes.CRT && (
            <Document renderMode='canvas' onError={(e) => {console.log("!!!!", e)}} file={'/pdf/acreditation/crt/Autorizacion CRT 2026.pdf'}>
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={0} />
              <Page renderAnnotationLayer={false} renderTextLayer={false} pageIndex={1} />
            </Document>
          )}
        </div>
      </div>

    </div>
  );
}

export default AccreditationPage;